import React, { Component } from 'react';
import './TechItem.css';

class TechItem extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        this.props.toggleTech(this.props.name);
    }

    render() {
        return (
            <span className={'tech-item badge rounded-0' + (this.props.isSelected ? ' badge-dark border' : ' badge-light border')}
                onClick={this.handleClick}>{this.props.name}</span>
        );
    }
}

export default TechItem;